<template>
  <div>
    <b-button
      v-track-click
      id="export-popover"
      variant="secondary"
      class="w-100 mb-3 p-3"
    >
      {{ $t('invoices.index.exportData.title') }}
    </b-button>
    <b-popover
      target="export-popover"
      triggers="click"
      placement="auto"
      id="export-invoice-data"
      :show.sync="popoverShow"
      ref="popover"
    >
      <template slot="title">
        <b-button @click="onClose" class="close close-btn" aria-label="Close">
          <span class="d-inline-block mb-1" aria-hidden="true">&times;</span>
        </b-button>
        {{ $t('invoices.index.exportData.exportInvoicesData') }}
      </template>
      <div>
        <b-form-group
          :label="$t('invoices.index.exportData.labels.from')"
          label-for="export-from-date"
          label-cols-lg="3"
          class="mb-1"
          invalid-feedback="This field is required"
        >
          <date-picker
            placeholder="dd/mm/yyyy"
            id="export-from-date"
            autocomplete="off"
            name="user_due_date"
            v-model="input.from"
            :config="options"
            v-validate="'required'"
          />
        </b-form-group>
        <b-form-group
          :label="$t('invoices.index.exportData.labels.to')"
          label-for="export-to-date"
          label-cols-lg="3"
          class="mb-1"
          invalid-feedback="This field is required"
        >
          <date-picker
            placeholder="dd/mm/yyyy"
            id="export-to-date"
            autocomplete="off"
            name="user_due_date"
            v-model="input.to"
            :config="options"
            v-validate="'required'"
          />
        </b-form-group>
        <b-button @click="exportData" size="sm" variant="primary">
          {{ $t('invoices.index.exportData.export') }}
        </b-button>
      </div>
    </b-popover>
  </div>
</template>
<script>
import DatePicker from 'vue-bootstrap-datetimepicker'
import moment from 'moment'
import downloadService from '@/services/download/'
import exportersService from '@/services/exporters'

export default {
  data() {
    return {
      input: {
        from: '',
        to: ''
      },
      input1Return: '',
      input2Return: '',
      popoverShow: false
    }
  },
  methods: {
    onClose() {
      this.popoverShow = false
    },
    formatDate(str) {
      if (moment(str, 'DD/MM/YYYY').isValid()) {
        return moment(str, 'DD/MM/YYYY').format('YYYY-MM-DD')
      }
      return ''
    },
    fileName() {
      return `invoices-${this.formatDate(this.input.from)}-${this.formatDate(
        this.input.to
      )}.xlsx`
    },
    exportData() {
      const fromDate = this.formatDate(this.input.from)
      const toDate = this.formatDate(this.input.to)
      if (fromDate && toDate) {
        return exportersService
          .fetchExportersInvoiceStatement(
            this.$store.state.account.accountId,
            {
              vars: {
                from: fromDate,
                upto: toDate
              },
              filename: this.fileName()
            },
            'blob'
          )
          .then((res) => {
            this.$mpTrack('Download PDF of invoice list', {
              from: fromDate,
              upto: toDate
            })
            this.onClose()
            downloadService.downloadPDF(res.data, this.fileName())
          })
          .catch(() => {
            this.$mpTrack('Download PDF of invoice list failed', {
              from: fromDate,
              upto: toDate
            })
            this.onClose()
            this.$notify({
              type: 'error',
              title: this.$t('invoices.index.exportData.error')
            })
          })
      } else {
        this.$notify({
          type: 'error',
          title: this.$t('invoices.index.exportData.error')
        })
      }
    }
  },
  computed: {
    options() {
      return {
        format: 'DD/MM/YYYY',
        useCurrent: false,
        locale: this.$i18n.locale === 'es-MX' ? 'es' : 'en'
      }
    }
  },
  components: {
    DatePicker
  }
}
</script>
<style lang="scss" scoped>
.close-btn {
  line-height: 0.9;
}
</style>
